<template>
    <el-autocomplete v-model="itemSelect"
                     :name="name"
                     :fetch-suggestions="searchItem"
                     placeholder="Buscar por nombre, código interno del producto, escribir mínimo 2 caracteres"
                     :debounce="750"
                     @select="selectItem"
                     style="width: 100%">
        <template v-slot="{ item }">
            <div class="x-item-search">
                <div class="x-item-search_image"><img :src="item.image"/></div>
                <div class="x-item-search_information">
                    <div class="x-item-search_information_name">{{ item.name }}</div>
                    <div class="x-item-search_information_description">
                        <span v-if="item.information">{{ item.information }}</span>
                    </div>
                </div>
            </div>
        </template>
    </el-autocomplete>
</template>

<script>
export default {
    name: 'XInputItemSearch',
    props: {
        warehouseId: {
            default: 'all'
        },
        name: {
            type: String,
            default: 'x-input-item-search'
        }
    },
    data() {
        return {
            itemSelect: ''
        }
    },
    watch: {
        warehouseId(val) {
            this.itemSelect = '';
        }
    },
    methods: {
        async searchItem(input, cb) {
            let items = [];
            if (!_.isUndefined(input) && !_.isNull(input) && input.length > 1) {
                await this.$http.post(`/store/get_items`, {
                    'input': input,
                    'warehouse_id': this.warehouseId
                })
                    .then(response => {
                        items = response.data;
                    });
            }

            cb(items);
        },
        selectItem(item) {
            let it = {
                'id': item.id,
                'image': item.image,
                'name': item.name,
                'information': item.information,
                'stock_add': 0
            }
            this.$emit('select', it)
        }
    }
}
</script>
